<template>
  <div class="home">
    <div class="block block-rounded bg-gd-dusk mt-50">
      <div class="block-content bg-white-op-5">
        <div class="py-30 text-center">
          <h1 class="font-w700 text-white mb-10">Dashboard</h1>
          <h2 class="h4 font-w400 text-white-op">Bem-vindo ao sistema TecFy de Classificação de Dossiês.</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'home'
}
</script>
